<template>
	<div>
		<h2 style="margin-bottom: 30px;">潮剪集市详情</h2>
		<div class="father">
			<div class="left">
				<el-form label-width="150px" label-position="left" style="height: auto;">
					<el-form-item label="名称">
						<el-input v-model="sendData.name" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="选择券或券包">
						<el-radio-group v-model="sendData.coupon">
							<el-radio key="0" label="0" value="0">券</el-radio>
							<el-radio key="1" label="1" value="1">券包</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="sendData.coupon == 0" label="添加券">
						<el-tag v-if="sendData.couponId != '' && sendData.coupon == 0" style="margin: 5px 5px 0 0;">
							券id:{{sendData.couponId}}
						</el-tag>
						<el-button type="text" @click="dialog_quan=true"
							style="color:#999; border:2px dashed; width:100px;">
							<i class="el-icon-plus"></i>选择券
						</el-button>
					</el-form-item>
					<el-form-item v-if="sendData.coupon == 1" label="添加券包">
						<el-tag v-if="sendData.coupon == 1 && sendData.couponId != ''" style="margin: 5px 5px 0 0;">
							券包id:{{sendData.couponId}}
						</el-tag>
						<el-button type="text" @click="dialog_package=true"
							style="color:#999; border:2px dashed; width:100px;">
							<i class="el-icon-plus"></i>选择券包
						</el-button>
					</el-form-item>
					<el-form-item label="跳转地址">
						<el-input v-model="sendData.url" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="显示顺序">
						<el-input v-model="sendData.orderBy" style="width: 300px;"></el-input>
					</el-form-item>
					<el-form-item label="规则" style="height: 400px;">
						<quill-editor v-model="sendData.content" ref="myQuillEditor"
							style="height: 200px; width: 500px;">
						</quill-editor>
					</el-form-item>
					<el-form-item>
						<router-link to="/market">
							<el-button>取消</el-button>
						</router-link>
						<el-button @click="save()" type="primary" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="right">
				<el-form>
					<el-form-item label="上传图片">
						<div style="display: flex;">
							<div>
								<upload v-model="sendData.imageBig"  class="el-tabs-pane-upload"  ref="sss"
									style="width: 300px; height: 1080px;" />
								<p style="font-size: 14px;color: #808080;">点击上传详情页图片</p>
							</div>
							<div>
								<upload v-model="sendData.imageSmall"  class="el-tabs-pane-upload"  ref="sss"
									style="width: 100px; height: 100px; margin-top: 10px; margin-left: 30px;" />
								<p style="font-size: 14px;color: #808080; margin-left: 30px;">点击上传小图片</p>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible.sync="dialog_quan" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择优惠券</div>
				<span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_quan = false">取 消</el-button>
					<el-button type="primary" @click="dialog_quan = false">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"
								@click="selectCoupon(scope.row.title)"></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="title" align="center" label="名称"></el-table-column>
					<el-table-column prop="couponType" label="类型"></el-table-column>
					<el-table-column prop="storeNames" label="适用范围"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange01" @current-change="handleCurrentChange01"
						:current-page="filter.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialog_package" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择券包</div>
				<span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_package = false">取 消</el-button>
					<el-button type="primary" @click="dialog_package = false">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponPackageList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券包ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"
								@click="selectCoupon(scope.row.title)"></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="name" align="center" label="名称"></el-table-column>
					<!-- <el-table-column prop="coupons" label="优惠券"></el-table-column> -->
					<!-- <el-table-column prop="storeNames" label="适用范围"></el-table-column> -->
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<!-- 					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column> -->
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
						:current-page="filter2.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter2.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				filter: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				filter2: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				dialog_quan: false,
				dialog_package: false,
				onlyBuy: '',
				coupon: '',
				jumpMode1: '',
				jumpMode: [{
					value: "3",
					label: '打开新页面'
				}, {
					value: "2",
					label: '跳转tapbar页面'
				}, {
					value: "1",
					label: '跳转微信推文'
				}],
				sendData: {
					name: '',
					coupon: [],
					couponId: '',
					couponTitle: '',
					imageBig: '',
					imageSmall: '',
					jumpMode: [],
					url: '',
					orderBy: '',
					content: ''
				},
				couponList: [],
				couponPackageList: []
			}
		},
		mounted() {
			this.getCoupon();
			this.getCouponPackage();
			if (this.$route.query.id != null) {
				this.getDetail();
			}
		},
		methods: {
			getCoupon() {
				this.$http.get("dCoupon/list" + "?pageNum=" + this.filter.pageNum + "&pageSize=" + this.filter.pageSize)
					.then(res => {
						this.couponList = res.body.data;
						this.filter.total = res.body.total;
					})
			},
			getCouponPackage() {
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.filter2)).then(res => {
					this.couponPackageList = res.body.data;
					this.filter2.total = res.body.total;
				})
			},
			getDetail() {
				this.$http.get("member/detail" + "?id=" + this.$route.query.id).then(res => {
					var a = res.body.data;
					this.sendData = a;
					this.sendData.name = a.name;
					this.sendData.coupon = a.coupon.toString();
					this.sendData.couponId = a.couponId;
					this.sendData.imageBig = a.imageBig;
					this.sendData.imageSmall = a.imageSmall;
					this.sendData.url = a.url;
					this.sendData.orderBy = a.orderBy;
					this.sendData.content = a.content;
				})
			},
			save() {
				let a = {
					id: this.$route.query.id,
					name: this.sendData.name,
					coupon: this.sendData.coupon.toString(),
					couponId: this.sendData.couponId,
					imageBig: this.sendData.imageBig,
					imageSmall: this.sendData.imageSmall,
					url: this.sendData.url,
					orderBy: this.sendData.orderBy,
					content: this.sendData.content
				}
				// this.$http.post("member/saveOrUpdateDetail",JSON.stringify(a)).then(res => {
				// 	if (res.body.code == 200) {
				// 		this.$message.success("保存成功")
				// 		this.$router.push("/appletSettings");
				// 	} else {
				// 		this.$message.error(res.body.msg);
				// 	}
				// })
			},
			selectCoupon(title) {
				this.sendData.couponTitle = title
			},
			handleSizeChange01(val) {
				this.filter.pageSize = val;
				this.getCoupon();
			},
			handleCurrentChange01(val) {
				this.filter.pageNum = val;
				this.getCoupon();
			},
			handleSizeChange02(val) {
				this.filter2.pageSize = val;
				this.getCouponPackage();
			},
			handleCurrentChange02(val) {
				this.filter2.pageNum = val;
				this.getCouponPackage();
			}
		}
	}
</script>

<style lang="less" scoped>
	.father {
		display: flex;
	}

	.left {
		/* background-color: #0000CC; */
		width: 50%;
	}

	.right {
		/* background-color: #008200; */
		width: 50%;
		height: auto;
		float: right;
	}
</style>